import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SelectList } from 'react-widgets';
import { Field } from 'formik';
import FormikPickList from '../../../../../components/formik-components/FormikPicklist';
import {
  LegacyInputTextComponent,
  DropdownWithValidation,
} from '../../../../../components/prime-formik';

const dimensionTemplate = dimension => (
  <div className="p-clearfix">
    <div>{dimension.displayName}</div>
  </div>
);


export const DimensionSelection = (props) => {
  const {
    dimensions, text, fieldName, setFieldValue,
  } = props;
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <h3 className="no-margin">{text}</h3>
      </div>
      <div className="p-col-12">
        <Field
          id={fieldName}
          name={fieldName}
          component={FormikPickList}
          source={dimensions}
          template={dimensionTemplate}
          setFieldValue={setFieldValue}
          idKey="name"
          showSourceControls={false}
          showTargetControls={false}
        />
      </div>
    </div>
  );
};

DimensionSelection.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.any).isRequired,
  text: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export const DistortionSelection = (props) => {
  const {
    dimensions, fieldName, setFieldValue,
  } = props;
  return (
    <div className="p-col-12">
      <h3>
        <FormattedMessage id="jobMatching.distortion" defaultMessage="Distortion" />
      </h3>
      <Field
        id={fieldName}
        name={fieldName}
        component={FormikPickList}
        source={dimensions}
        template={dimensionTemplate}
        setFieldValue={setFieldValue}
        idKey="name"
        showSourceControls={false}
        showTargetControls={false}
      />
    </div>
  );
};

DistortionSelection.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.any).isRequired,
  fieldName: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export const DimensionNoFormSelection = (props) => {
  const { dimensions, text } = props;
  return (
    <div>
      <h3>{text}</h3>
      <div className="select-list-section">
        <SelectList data={dimensions} multiple valueField="value" textField="text" />
      </div>
    </div>
  );
};

DimensionNoFormSelection.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.any).isRequired,
  text: PropTypes.string.isRequired,
};

export const InterestDimensionSelection = (props) => {
  const {
    dimensions, fieldName, setFieldValue,
  } = props;
  const checkbox = (
    <div className="p-col-12">
      <h3>
        <FormattedMessage id="jobMatching.interestSection" defaultMessage="Interests Section" />
      </h3>
      <Field
        id={fieldName}
        name={fieldName}
        component={FormikPickList}
        className="interest-section-picklist"
        source={dimensions}
        template={dimensionTemplate}
        setFieldValue={setFieldValue}
        idKey="name"
        showSourceControls={false}
        showTargetControls={false}
      />
    </div>
  );
  return checkbox;
};

export const General = () => (
  <div className="p-grid p-fluid">
    <div className="p-col-12 form-group" key="title">
      <label className="field-label" htmlFor="title">
        <FormattedMessage id="temp.title" defaultMessage="Title" />
      </label>
      <FormattedMessage id="attrs.name" defaultMessage="Name">
        {text => <Field id="title" name="title" component={LegacyInputTextComponent} placeholder={text} />}
      </FormattedMessage>
    </div>
  </div>
);

export const EmailTemplates = (props) => {
  const { templates } = props;
  const invites = templates.invites.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const thanks = templates.thanks.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const reminders = templates.reminders.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const feedbacks = templates.feedbacks.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));
  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <h3 className="no-margin" key="title">
          <FormattedMessage id="attrs.email_templates" defaultMessage="Email Templates" />
        </h3>
      </div>
      <div className="p-col-6 form-group" key="invite">
        <label className="field-label" htmlFor="inviteTemplateId">
          <FormattedMessage id="attrs.invite_email_template" defaultMessage="Invite Email Template" />
        </label>
        <Field id="invite" name="inviteTemplateId" component={DropdownWithValidation} options={invites} />
      </div>
      <div className="p-col-6 form-group" key="thank">
        <label className="field-label" htmlFor="thankYouTemplateId">
          <FormattedMessage id="attrs.thank_email_template" defaultMessage="Thank You Email Template" />
        </label>
        <Field id="thankyou" name="thankYouTemplateId" component={DropdownWithValidation} options={thanks} />
      </div>
      <div className="p-col-6 form-group" key="reminder">
        <label className="field-label" htmlFor="reminderTemplateId">
          <FormattedMessage id="attrs.reminder_email_template" defaultMessage="Reminder Email Template" />
        </label>
        <Field id="reminder" name="reminderTemplateId" component={DropdownWithValidation} options={reminders} />
      </div>
      <div className="p-col-6 form-group" key="feedback">
        <label className="field-label" htmlFor="feedbackTemplateId">
          <FormattedMessage id="attrs.feedback_email_template" defaultMessage="Feedback Email Template" />
        </label>
        <Field id="feedback" name="feedbackTemplateId" component={DropdownWithValidation} options={feedbacks} />
      </div>
    </div>
  );
};

EmailTemplates.propTypes = {
  templates: PropTypes.objectOf(PropTypes.any).isRequired,
};
